module.exports = __webpack_public_path__ + "static/open.49fe1ffd.png";